import React from 'react'
import {Popup} from 'semantic-ui-react'
import {TicketChip} from '../purchase-orders/ticket-chip'
import {ticketLabel} from '../purchase-orders/needs-tickets'
import {formatDate} from '../cads/format-date'

const notBlank = (x) => x != null && x.replace(' ', '') != ''

// ticketInfo is keyed by upcased ponumber — see Api::Cads2Controller#ticket_info.
// No entry means the order does not need tickets, or has no ERP purchase_order row.
const getTicketInfoFor = (ticketInfo, ponumber) => {
  if (ticketInfo == null || ponumber == null) { return null }
  return ticketInfo[ponumber.trim().toUpperCase()]
}

const ticketChipPopup = (ticketInfo, ponumber) => {
  let info = getTicketInfoFor(ticketInfo, ponumber)
  if (info == null) { return null }

  return (
    <Popup
      size='mini'
      header='This order needs tickets'
      content={
        <table style={{whiteSpace: 'nowrap'}}>
          <tbody>
            <tr><td style={{opacity: 0.5}}>Type &nbsp;</td><td style={{fontWeight: 'bold'}}>{ticketLabel(info.ticketed)}</td></tr>
            {
              info.tickets_ordered
              ?
              <tr><td style={{opacity: 0.5}}>Ordered on &nbsp;</td><td style={{fontWeight: 'bold'}}>{formatDate(info.tickets_ordered_date)}</td></tr>
              :
              <tr><td colSpan='2'><u>NOT ordered yet!</u></td></tr>
            }

            {notBlank(info.tickets_confirmation_number) ?
              <tr><td style={{opacity: 0.5}}>Confirmation # &nbsp;</td><td style={{textTransform: 'uppercase', fontWeight: 'bold'}}>{info.tickets_confirmation_number}</td></tr>
            : null}

            {notBlank(info.tickets_tracking_number) ?
              <tr><td style={{opacity: 0.5}}>Tracking # &nbsp;</td><td style={{textTransform: 'uppercase', fontWeight: 'bold'}}>{info.tickets_tracking_number}</td></tr>
            : null}
          </tbody>
        </table>
      }
      position='bottom left'
      trigger={
        <TicketChip ticketed={info.ticketed} ticketsOrdered={info.tickets_ordered}/>
      }
    />
  )
}

export {ticketChipPopup, getTicketInfoFor}
